import mediaObjectUpload from "@/helpers/mediaObjectUpload";
var randomBytes = require("randombytes");
const UPLOAD_REF = "mediaUpload-" + randomBytes(16).toString("hex");
import { AUTH_TOKEN } from "@/apollo/vue-apollo";

export default {
  props: {
    formats: String,
    maxSizeBytes: Number,
    errorTooLargeMessage: String,
    requirements: Object,
  },
  methods: {
    async onFileUpload(event, jwt) {
      let vm = this;
      this.$emit('error', '')
      this.$emit('loading', true)
      vm.loading = true;
      try {
        let response = await mediaObjectUpload(event, jwt, this.maxSizeBytes, this.requirements);
        this.objectUrl = response.data.contentUrl;
        this.$emit('newId',response.data['@id'])
        let fileInfo = {
          id: response.data['@id'],
          size: response.data['fileSize'],
          length: response.data['playtimeSeconds'],
          format: response.data['fileFormat'],
        }
        this.$emit('fileInfo', fileInfo)
        this.$emit('loading', false)
      } catch (e) {
        this.$emit('loading', false)
        if (e && e.name == "FileTooLargeError") 
        {
          this.$emit('error', this.errorTooLargeMessage)
        }
        else {
          this.$emit('error', e.message)
        }
      }
    },
  },
  data() {
    return {
      objectUrl: "",
    };
  },
  watch: {
    objectUrl(newValue) {
      this.$emit("input", newValue);
    },
  },
  computed: {
    uploadRef() {
      return UPLOAD_REF;
    },
    jwt() {
      return localStorage.getItem(AUTH_TOKEN);
    },
  },
}